import { Component } from '@angular/core';
import { ProviderNotifiedAssessment } from 'src/app/calvin-emr-shared/models/assessments/provider-notified.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { BooleanToYesNoPipe } from 'src/app/shared/utils/boolean-to-yes-no.pipe';

@Component({
  selector: 'app-provider-notified-info',
  standalone: true,
  template: `
    <div class="assessment-container">
      <h2>Provider Notified</h2>
      <assessment-row title="Provider Notified?" [historyMode]="true">
        <p>{{ (data().isNotified | booleanToYesNo) }}</p>
      </assessment-row>
      <assessment-row title="Who" [historyMode]="true">
        <p>{{ data().notifiedPerson }}</p>
      </assessment-row>
      <assessment-row title="What" [historyMode]="true">
        <p>{{ data().notifiedWhat }}</p>
      </assessment-row>
    </div>
  `,
  styles: [`
    .assessment-container {
      padding-top: 1.5rem !important;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `],
  imports: [
    AssessmentRowComponent,
    BooleanToYesNoPipe,
  ],
})
export class ProviderNotifiedInfoComponent extends AssessmentInfoComponent<ProviderNotifiedAssessment> {}
